import { render } from "./main.html?vue&type=template&id=77302ffe&ts=true"
import script from "./main.ts?vue&type=script&lang=ts"
export * from "./main.ts?vue&type=script&lang=ts"

import "./main.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/antonio/work/zanzar/inventario-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__